import './style.scss'

export function SignalInfo({ icon, iconAlt = '', title = '', children }) {
  return (
    <div className='signal-info'>
      <div className='header'>
        <img src={icon} alt={iconAlt} className='icon' />
        <h3 className='title'>{title}</h3>
      </div>
      <div className='content'>{children}</div>
    </div>
  )
}
